import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-page-size-menu',
  templateUrl: './page-size-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageSizeMenuComponent {
  @Input() disabled = false;
  @Input() pageSize = 10;
  @Input() values = [10, 25, 50, 100];
  @Output() valueChanges = new EventEmitter<number>();

  changeValue(value: number): void {
    this.pageSize = value;
    this.valueChanges.emit(this.pageSize);
  }
}
